import React, {Fragment, useState} from 'react';
import {observer} from "mobx-react";
import chroma from "chroma-js";

const shines = [0.25, -0.1, -0.25, -0.35, -0.2, -0.15, 0.35];

function Gem(props) {
    const {cx, cy, fill, stroke, r, activated, progress, strength, onClick, onMouseEnter, onMouseLeave, clickable} = props;

    let tessStyle = (val) => {
        if (fill === 'none' || !activated) return {fill: 'none'};
        if (val >= progress) return {fill: 'none'};

        let shine = shines[val];
        let color = chroma(fill);
        if (shine > 0) {
            color = color.brighten(shine * strength);
        } else {
            color = color.darken(-shine * strength);
        }

        return {fill: color};
    };

    const fillStyle = () => {
        if (!activated) return '#eeeeee';
        return fill;
    };
    const strokeStyle = () => {
        // let color = chroma(stroke);
        // if (activated) return color.darken(1.2);
        return stroke;
    };
    const strokeWidth = () => {
        return (activated) ? 1 : 1.5;
    };
    let className = 'Gem';
    className += (!clickable) ? ' click-through' : '';

    return (
        <Fragment>
            <g className={className} transform={`translate(${cx},${cy}) scale(${r / 16})`} onClick={onClick}
               onMouseLeave={onMouseLeave} onMouseEnter={onMouseEnter}>
                <path
                    fill={fillStyle()}
                    stroke={strokeStyle()} strokeWidth={strokeWidth()}
                    d="M -0.01504269,16.83729 -13.21038,10.482748 -16.469361,-3.7957765 -7.337905,-15.246267 7.3078198,-15.246268 16.439283,-3.7957777 13.180303,10.482747 Z"/>
                <g
                    className="tess">
                    <path
                        style={tessStyle(0)}
                        d="M -7.3146108,-15.180277 7.2967922,-15.181157 5.702e-4,-0.03054187 Z"/>
                    <path
                        style={tessStyle(1)}
                        d="M 7.2928813,-15.188031 16.403644,-3.7649358 0.00930424,-0.02307556 Z"/>
                    <path
                        style={tessStyle(2)}
                        d="M 16.406581,-3.7722764 13.156133,10.47299 0.00891278,-0.01159777 Z"/>
                    <path
                        style={tessStyle(3)}
                        d="M 13.163703,10.470706 -3.0967e-4,16.811198 V -0.00474557 Z"/>
                    <path
                        style={tessStyle(4)}
                        d="M 0.00605052,16.815694 -13.158727,10.47679 -0.01141397,-0.00767967 Z"/>
                    <path
                        style={tessStyle(5)}
                        d="M -13.158188,10.48468 -16.410353,-3.7601953 -0.01604315,-0.01819499 Z"/>
                    <path
                        style={tessStyle(6)}
                        d="M -16.416186,-3.754855 -7.3067998,-15.179045 -0.01071007,-0.02836914 Z"/>

                </g>
            </g>
        </Fragment>
    );
}

Gem.defaultProps = {
    strength: 8,
    stroke: '#ffffff',
    strokeWidth: 1.35,
    clickable: true,
};

export default observer(Gem);
